import { useQuery } from 'react-query';
import { storeClient, endpoints } from '../api/client';

export interface CountryOption {
  code: string;
  name: string;
}

async function fetchCountries(): Promise<CountryOption[]> {
  const response = await storeClient.get<Record<string, string>>(endpoints.storeCountries);
  const map = response.data;
  if (!map || typeof map !== 'object') return [];
  return Object.entries(map)
    .map(([code, name]) => ({ code, name }))
    .sort((a, b) => a.name.localeCompare(b.name));
}

/**
 * Fetches the full ISO 3166-1 alpha-2 country list from the store service.
 * The endpoint is public (no auth required) so this can be called early.
 */
export const useCountries = () => {
  return useQuery<CountryOption[]>(
    'storeCountries',
    fetchCountries,
    {
      staleTime: 30 * 60 * 1000,
      retry: 2,
    }
  );
};
